import { Navigate, Route, Routes } from "react-router-dom"
import { AuthLayout } from "@/components/layouts/AuthLayout"
import { MainLayout } from "@/components/layouts/MainLayout"
import { ProtectedRoute } from "@/features/auth/components/ProtectedRoute"
import { ForbiddenPage } from "@/pages/forbidden/ForbiddenPage"
import { SigninPage } from "@/pages/signin/SigninPage"
import { devRoutes, protectedRoutes, publicRoutes } from "./routeConfig"

export function AppRoutes() {
  return (
    <Routes>
      {/* Dev Routes */}
      <Route>
        {devRoutes.flatMap((category) =>
          category.routes.map((route) => {
            const Component = route.component
            return Component ? (
              <Route key={route.path} path={route.path} element={<Component />} />
            ) : null
          })
        )}
        {/* Legacy login route */}
        <Route element={<AuthLayout />}>
          <Route path="/signin" element={<SigninPage />} />
        </Route>
      </Route>

      {/* Auth Routes */}
      <Route element={<AuthLayout />}>
        {publicRoutes.flatMap((category) =>
          category.routes.map((route) => {
            const Component = route.component
            return Component ? (
              <Route key={route.path} path={route.path} element={<Component />} />
            ) : null
          })
        )}
      </Route>

      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<MainLayout />}>
          {protectedRoutes.flatMap((category) =>
            category.routes.map((route) => {
              const Component = route.component
              return Component ? (
                <Route key={route.path} path={route.path} element={<Component />} />
              ) : null
            })
          )}
          {/* 403 Forbidden Page */}
          <Route path="/forbidden" element={<ForbiddenPage />} />
        </Route>
      </Route>

      {/* Root redirect */}
      <Route path="/" element={<Navigate to="/tickets" replace />} />

      {/* 404 */}
      <Route path="*" element={<Navigate to="/tickets" replace />} />
    </Routes>
  )
}
